// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IfKAUhDLTnULp42Gixa0 {
  display: grid;
  grid-template-columns: 0.5fr 1fr 1fr;
  align-items: baseline;
  gap: 32px;
  margin: 7.5px 0;
}

.dVGUmMlhWNE08bncl_wq {
  display: flex;
  gap: 8px;
  position: relative;
  top: 0;
  cursor: pointer;
}

.o03oO1otkDWH2v7cHviY {
  font-family: var(--font-stack-full-regular);
  line-height: 1.5;
  font-size: 1rem;
  font-weight: 500;
  color: var(--grey-color-90);
}

.uDQ_uVaZM0H5SKbyA2bw {
  width: 100%;
  margin-top: 16px;
  padding-left: 12px;
}

.ND2zQi_UOy4nHErLt65d {
  padding: 6px 12px;
  background-color: var(--grey-color-10);
  border-radius: 12px;
}

.ncbv7ZSAJ8_aRwG3iX2o {
  margin-right: 16px;
}

.wHwVSZiDkEjEopVdaM8c {
  margin-bottom: 18px;
}

.gtMUfPi17LzRkl7zEwSl {
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  font-family: var(--font-stack-full-medium);
  color: var(--grey-color-90);
}

.dEmvnFMs0Rsy6uvLHiSv {
  height: 1px;
  margin-bottom: 24px;
  background-color: var(--grey-color-200);
}

.LWhLcTZnudwKTuu6BEXa {
  width: 100%;
  margin: 24px 0 12px;
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  font-family: var(--font-stack-full-medium);
  display: grid;
  grid-template-columns: 0.5fr 1fr 1fr;
  align-items: baseline;
  gap: 32px;
}

.VwnnWfesSZTWaY9nxM_5 {
  flex: 1 1 48%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 32px;
}

.z0FGst6uJ2qkErfzYhfH {
  display: flex;
  gap: 2px;
}

.BkwimtwBsrN4z9f7zSQb {
  width: 50%;
}

.OUphU4GujYmGmADZL0Jg {
  margin: 0 0 24px 0;
}`, "",{"version":3,"sources":["webpack://./src/components/DrilldownFactorChart/DrilldownFactorChart.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oCAAA;EACA,qBAAA;EACA,SAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;AACF;;AAEA;EACE,2CAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;EACA,sCAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,2BAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;EACA,uCAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,aAAA;EACA,oCAAA;EACA,qBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,kBAAA;AACF","sourcesContent":[".scoringFactorChartContainer {\n  display: grid;\n  grid-template-columns: 0.5fr 1fr 1fr;\n  align-items: baseline;\n  gap: 32px;\n  margin: 7.5px 0;\n}\n\n.scoreLabelContainer {\n  display: flex;\n  gap: 8px;\n  position: relative;\n  top: 0;\n  cursor: pointer;\n}\n\n.scoringLabel {\n  font-family: var(--font-stack-full-regular);\n  line-height: 1.5;\n  font-size: 1rem;\n  font-weight: 500;\n  color: var(--grey-color-90);\n}\n\n.singleFactorChartContainer {\n  width: 100%;\n  margin-top: 16px;\n  padding-left: 12px;\n}\n\n.sectionTitleContainer {\n  padding: 6px 12px;\n  background-color: var(--grey-color-10);\n  border-radius: 12px;\n}\n\n.averageScoreContainer {\n  margin-right: 16px;\n}\n\n.mainTitleContainer {\n  margin-bottom: 18px;\n}\n\n.titleContainer {\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 32px;\n  font-family: var(--font-stack-full-medium);\n  color: var(--grey-color-90);\n}\n\n.dividerLine {\n  height: 1px;\n  margin-bottom: 24px;\n  background-color: var(--grey-color-200);\n}\n\n.singleProjectSelectionInfo {\n  width: 100%;\n  margin: 24px 0 12px;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 32px;\n  font-family: var(--font-stack-full-medium);\n  display: grid;\n  grid-template-columns: 0.5fr 1fr 1fr;\n  align-items: baseline;\n  gap: 32px;\n}\n\n.averageScoreLabelContainer {\n  flex: 1 1 48%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-right: 32px;\n}\n\n.arrowAndTargetContainer {\n  display: flex;\n  gap: 2px;\n}\n\n.distributionLevelTitle {\n  width: 50%;\n}\n\n.factorChartSingleSectionContainer {\n  margin: 0 0 24px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scoringFactorChartContainer": `IfKAUhDLTnULp42Gixa0`,
	"scoreLabelContainer": `dVGUmMlhWNE08bncl_wq`,
	"scoringLabel": `o03oO1otkDWH2v7cHviY`,
	"singleFactorChartContainer": `uDQ_uVaZM0H5SKbyA2bw`,
	"sectionTitleContainer": `ND2zQi_UOy4nHErLt65d`,
	"averageScoreContainer": `ncbv7ZSAJ8_aRwG3iX2o`,
	"mainTitleContainer": `wHwVSZiDkEjEopVdaM8c`,
	"titleContainer": `gtMUfPi17LzRkl7zEwSl`,
	"dividerLine": `dEmvnFMs0Rsy6uvLHiSv`,
	"singleProjectSelectionInfo": `LWhLcTZnudwKTuu6BEXa`,
	"averageScoreLabelContainer": `VwnnWfesSZTWaY9nxM_5`,
	"arrowAndTargetContainer": `z0FGst6uJ2qkErfzYhfH`,
	"distributionLevelTitle": `BkwimtwBsrN4z9f7zSQb`,
	"factorChartSingleSectionContainer": `OUphU4GujYmGmADZL0Jg`
};
export default ___CSS_LOADER_EXPORT___;
